import { isEmpty, isNull } from "lodash";
import React, { useEffect } from "react";
import {
  DISPLAY_DATA_GUARD_ALERT_COMMENT,
  SAVE_DATA_GUARD_COMMENT,
  SET_DATA_GUARD_ALERT_COMMENT,
} from "../Utility/DataguardConstant";
import { useDispatch, useSelector } from "react-redux";
import { maskUsername } from "../../SysGuard/SysGuardCommonComp"
import TextField from "@material-ui/core/TextField";
import DoneIcon from "@material-ui/icons/Done";
import { updateAlertStatus } from "./ActionCreator";
import { DeleteButtonForToolBar } from "../../../components/common/buttons";
import ClearIcon from "@material-ui/icons/Clear";

const DataGuardAlertInfoBox = ({ data, loc, parentData }) => {
  const isIncognito = useSelector((state) => state.DataguardReducer.incognito);
  const alertComment = useSelector((state) => state.DataguardReducer.alertComment);
  const alertStatus = useSelector((state) => state.DataguardReducer.alertStatus);
  const displayAlertComment = useSelector(
      (state) => state.DataguardReducer.displayAlertComment
    );
  const dispatch = useDispatch();
  const alertInfo = data?.alertInfo;
  const alertId = data?.alertId;
  const ipInfo = data?.ipInfo;
  const ticketIds = data?.ticketIds;
  const userNameInfo =
    isIncognito
      ? maskUsername(data?.userName)
      : data?.userName;

  // Clear comment when switching to a different alert
  useEffect(() => {
    // Clear the comment and hide comment section when alertId changes
    dispatch({
      type: SET_DATA_GUARD_ALERT_COMMENT,
      payload: null
    });
    dispatch({
      type: DISPLAY_DATA_GUARD_ALERT_COMMENT,
      payload: false,
    });
  }, [alertId, dispatch]);

  const handleNewComment = (e) => {
    const comment = e.target.value;
    dispatch({ type: SET_DATA_GUARD_ALERT_COMMENT, payload: comment });
  };

  const handleSaveComment = () => {
    if (!isEmpty(alertComment) || !isNull(alertComment)) {
      dispatch({
        type: SAVE_DATA_GUARD_COMMENT,
        payload: { id: alertId, comment: alertComment },
      });
    }
    dispatch(
      updateAlertStatus({
        status: alertStatus,
        ids: [`${alertId}`],
        sysGuardData: parentData,
      })
    );
    dispatch({
      type: DISPLAY_DATA_GUARD_ALERT_COMMENT,
      payload: false,
    });
  };

  const renderCommentSection = () => {
    return (
      <div className="sys-guard-alert-box-container">
        <TextField
          id="outlined-multiline-static"
          multiline
          rows={4}
          placeholder="Add Comments or Continue"
          variant="outlined"
          value={alertComment}
          onChange={(e) => handleNewComment(e)}
          style={{ width: "100%" }}
        />
        <div className="alert-button-container">
          <DeleteButtonForToolBar
            style={{ float: "right" }}
            variant="contained"
            id="delete"
            size="small"
            color="primary"
            onClick={() => handleSaveComment()}
            className="min-margin"
          >
            <DoneIcon />
          </DeleteButtonForToolBar>
          <DeleteButtonForToolBar
            style={{ float: "right" }}
            variant="contained"
            id="delete"
            size="small"
            color="primary"
            onClick={() => {
              dispatch({
                type: DISPLAY_DATA_GUARD_ALERT_COMMENT,
                payload: false,
              });
              dispatch({
                type: SET_DATA_GUARD_ALERT_COMMENT,
                payload: null
              })
            }}
            className="min-margin"
          >
            <ClearIcon />
          </DeleteButtonForToolBar>
        </div>
      </div>
    );
  };

  const renderInfoBox = () => {
    if (displayAlertComment) {
      return renderCommentSection();
    } else {
      return (
        <div className="parent-container">
          {loc === "location_country_dataSource_anomalies" && (
            <div className="child-container-two">
              <div className="child-container">
                <div className="para-name">IP Address:</div>
                <div className="break-words">{ipInfo}</div>
              </div>
            </div>
          )}
          <div className="child-container">
            <div className="break-words">{alertInfo}</div>
          </div>
        </div>
      );
    }
  };

  return (
    <div className="sys-guard-info-box dataguard-info-box">
      <h2>Alert Details</h2>
      {!isNull(alertInfo) && alertInfo ? (
        renderInfoBox()
      ) : (
        <div>Select a row to view alert information.</div>
      )}
    </div>
  );
};

export default DataGuardAlertInfoBox;
